<template>
    <div class="row">
        <div class="col-md-12">

            <div class="card mb-5">

                <div class="card-body placeholder-img text-center">
                    <div :class="['ih-box', opt.wrapperClass ]">
                        <img :src='model[field] ? model[field] : opt.defaultImage' :class='[ opt.imageClass ]' width="100%" alt="Project cover image">
                        <span v-if="!model[field]" class="icon icon-upload-cloud d-block mb-2"></span>
                    </div>
                </div>
                
                <div class="card-body browse-img">
                    <div class="control-wrap">
                        <div :id='id + "-hld"' class="input-group mb-3 ">
                            <div class="custom-file">
                                <input :id='id + "-fs"'
                                        @change='imgChange($event)'
                                        :data-value='model[field] ? model[field] : 0'
                                        type='file' class='form-control custom-file-input' />
                                    <label class="custom-file-label" :for='id + "-fs"'>{{ fname }}</label>
                            </div>
                        </div>
                        <div :id='id + "-err"'></div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if='!modal'>
            <div v-show='mode == "crop"' class='col-md-12'>
                <div>
                    <img :id='id' :src='cropSrc'/>
                </div>
                <div>
                    <button @click.prevent='setImage()' type='button' class='btn btn-primary'>Готово</button>
                </div>
            </div>
        </div>

        <div v-if='modal' class="modal fade" :id='"cropModal-" + this.id' role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header title d-flex justify-content-between">                      
                      <h4 class="modal-title">Изрязване на изображение</h4>
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class='crop-img-modal col-md-12 text-center'>
                                <img :id='id' :src='cropSrc' style='min-width : 400px; max-height: 400px'/>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent='setImage()' type='button' class='btn btn-primary'>
                            Готово
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        mounted() {
            var me = this;

            $("#cropModal-" + this.id ).appendTo($('body'));

            $("#cropModal-" + this.id ).on('hidden.bs.modal', function(){
                me.mode = 'field';

                if( !me.isChanged && !me.model[ me.field ]  ){
                    
                    document.getElementById( me.id + "-fs" ).value = "";
                    me.fname = 'Избери файл';

                }

                if( typeof me.inModal == 'boolean' && me.inModal ) {
                    if( !$("body").hasClass('modal-open') ) {
                        $("body").addClass('modal-open');
                    }
                }
            })
        },

        created() {
            if(typeof this.f == 'string'){
                this.field = this.f;
            }

            if(typeof this.options == 'object'){
                this.opt = Object.assign({}, this.opt, this.options);

                if( typeof this.opt.id != 'undefined' ){
                    this.id = this.opt.id;
                }
            }
        },

        destroyed(){
            $("#cropModal-" + this.id ).remove();
        },

        props : ['model','f','options','inModal','emitChange'],

        data(){
            return {
                field   : 'image',
                id      : 'ih-img-' + this._uid ,
                cropSrc : '',
                mode    : 'field',

                modal   : true,
                fname   : 'Избери файл',
                ext     : 'jpg',

                opt     : {
                    width        : 1920,
                    height       : 1080,
                    maxFileSize  : 5000000,
                    chooseText   : "Избери",
                    changeText   : "Промени",
                    allowedTypes : ['image/jpeg','image/png','image/webp'],
                    textTitle    : 'Профилна снимка',
                    imgClass     : '',
                    defaultImage : "/resources/images/default.jpg",
                    imageClass   : "place-img",
                    nameAddon    : false
                },

                shouldAdd : false,
            }
        },

        methods : {
            fileSelect(){
                $("#" + this.id + "-fs").trigger('click');
            },

            setImage() {
                $("#cropModal-" + this.id ).modal('hide');
                var image = $('#' + this.id).cropper('getCroppedCanvas').toDataURL(/*'image/jpeg'*/);

                this.model[this.field] = image;
                this.mode = 'field';

                this.$emit('image-set');
            },

            imgChange(event){
                var me      = this;
                var input   = $(event.target);

                if (event.target.files) {
                    var file = event.target.files[0];

                    if(typeof file == 'undefined'){
                        input.val('');
                        return;
                    }

                    me.fname = file.name;
                    var ext  = file.name.split('.').reverse()[0];

                    me.ext = ext;

                    if( typeof this.emitChange == 'string' ) {
                        
                        bus.$emit( this.emitChange, {
                            fname : me.fname,
                            ext   : me.ext
                        });

                    }

                    if( file.size > this.maxFileSize ){
                        alert('Моля прикачете файл по малък от 15 MB.');
                        input.val('');
                        return false;
                    }

                    if( this.opt.allowedTypes.indexOf( file.type ) < 0 ){
                        alert('Image type not accepted :' + file.type);
                        input.val('');
                        return false;
                    }

                    var reader = new FileReader();

                    //Loader start
                    reader.onload = function(event) {
                        //Loader finish
                        me.initCropper(event.target.result);
                    }

                    reader.readAsDataURL(file);
                }
            },

            init(el){

            },

            initCropper(src){
                var me = this;

                me.destroyCropper();

                this.mode    = 'crop';

                $("#cropModal-" + this.id ).on('shown.bs.modal', function(){
                    $('#' + me.id).cropper({
                        viewMode: 2,
                        aspectRatio         : me.opt.width / me.opt.height,
                        checkCrossOrigin    : false,
                        scalable            : false,
                        cropBoxResizable    : false,
                        zoomable            : true,
                        rotatable           : true,
                        movable             : false,

                        crop: function(e) {

                        }
                    });
                })

                // $("#cropModal-" + this.id ).on('hidden.bs.modal', function(){
                //     if( me.shouldAdd ){
                //         $("body").addClass('modal-open');
                //     }
                // })

                var img = document.getElementById(this.id);
                
                if( img.complete ){
                     $("#cropModal-" + this.id ).modal('show');
                }

                img.addEventListener('load', function(e){
                    //Check if modal already opened
                    if( $("body").hasClass('modal-open') ){
                        me.shouldAdd = true;
                    }else{
                        me.shouldAdd = false;
                    }

                    $("#cropModal-" + this.id ).modal('show');
                })

                this.cropSrc = src;
            },

            destroyCropper(){
                $("#" + this.id ).cropper('destroy');
            }
        },

        watch : {

        }
    }
</script>
<style>
.crop-img-modal .cropper-container{
    margin: auto;
}
.ih-box{
}
</style>
